import { Filter, Mail, Phone, CheckCircle2 } from "lucide-react";

export const STATUSES = ["pending", "confirmed", "completed", "cancelled"];

const BADGE_STYLES = {
  pending: "bg-amber-100 text-amber-800",
  confirmed: "bg-blue-100 text-blue-800",
  completed: "bg-green-100 text-green-800",
  cancelled: "bg-red-100 text-red-800",
};

function StatusBadge({ status }) {
  return (
    <span className={`text-[10px] uppercase tracking-[0.18em] px-2.5 py-1 rounded-full ${BADGE_STYLES[status] || "bg-gray-100 text-gray-700"}`}>
      {status}
    </span>
  );
}

export default function BookingsPanel({ bookings, filter, setFilter, onStatusChange }) {
  return (
    <div className="card-surface overflow-hidden" data-testid="bookings-panel">
      <div className="p-5 border-b border-black/5 flex items-center gap-3 flex-wrap">
        <Filter size={14} className="text-muted2" />
        <span className="eyebrow">Filter:</span>
        <button
          onClick={() => setFilter("")}
          className={`text-xs px-3 py-1.5 rounded-full ${!filter ? "bg-forest text-white" : "bg-bone border border-black/10"}`}
          data-testid="filter-all"
        >All</button>
        {STATUSES.map((s) => (
          <button
            key={s}
            onClick={() => setFilter(s)}
            className={`text-xs px-3 py-1.5 rounded-full capitalize ${filter === s ? "bg-forest text-white" : "bg-bone border border-black/10"}`}
            data-testid={`filter-${s}`}
          >{s}</button>
        ))}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-bone/60">
            <tr className="text-left">
              <th className="px-5 py-3 eyebrow">Date</th>
              <th className="px-5 py-3 eyebrow">Customer</th>
              <th className="px-5 py-3 eyebrow">Service</th>
              <th className="px-5 py-3 eyebrow">Location</th>
              <th className="px-5 py-3 eyebrow">Total</th>
              <th className="px-5 py-3 eyebrow">Status</th>
              <th className="px-5 py-3 eyebrow">Update</th>
            </tr>
          </thead>
          <tbody>
            {bookings.length === 0 && (
              <tr><td colSpan="7" className="px-5 py-10 text-center text-muted2">No bookings yet.</td></tr>
            )}
            {bookings.map((b) => (
              <tr key={b.id} className="border-t border-black/5" data-testid={`booking-row-${b.id}`}>
                <td className="px-5 py-4">
                  <div className="font-heading">{b.preferred_date}</div>
                  <div className="text-xs text-muted2">{b.time_slot}</div>
                </td>
                <td className="px-5 py-4">
                  <div className="font-medium">{b.name}</div>
                  <div className="text-xs text-muted2 flex items-center gap-1"><Mail size={10} /> {b.email}</div>
                  <div className="text-xs text-muted2 flex items-center gap-1"><Phone size={10} /> {b.phone}</div>
                </td>
                <td className="px-5 py-4">
                  <div>{b.package_name}</div>
                  {b.add_ons?.length > 0 && (
                    <div className="text-xs text-muted2">+ {b.add_ons.length} add-on(s)</div>
                  )}
                </td>
                <td className="px-5 py-4 text-xs">
                  <div>{b.address}</div>
                  <div className="text-muted2">{b.city}, {b.state}</div>
                </td>
                <td className="px-5 py-4 font-heading">
                  ${b.estimated_total}
                  {b.deposit_paid && (
                    <div className="text-[10px] uppercase tracking-[0.18em] text-forest mt-1 flex items-center gap-1">
                      <CheckCircle2 size={10} /> ${b.deposit_amount || 49} deposit
                    </div>
                  )}
                </td>
                <td className="px-5 py-4"><StatusBadge status={b.status} /></td>
                <td className="px-5 py-4">
                  <select
                    className="text-xs bg-white border border-black/10 rounded-lg px-2 py-1"
                    value={b.status}
                    onChange={(e) => onStatusChange(b.id, e.target.value)}
                    data-testid={`status-select-${b.id}`}
                  >
                    {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
